<div class="twoFa-form">
  <mat-icon
    class="shield-lock"
    svgIcon="shield-lock"></mat-icon>
  <h1>
    {{ ("twoFa" | i18n) || "Zwei-Faktor-Authentifizierung" }}
  </h1>
  <p class="authCodeSentToYourPhone">
    {{ ("authCodeSentTo" | i18n) || "Wir haben dir einen Bestätigungscode an" }}
    <b>{{
      (accountService.phoneNumber | async) || (accountService.email | async)
    }}</b>
    {{
      ("authCodeSentToYourPhone" | i18n) ||
        "geschickt. Bitte gib den Code hier ein."
    }}
  </p>
  <form
    class="twoFA__form"
    (ngSubmit)="submit()"
    [formGroup]="authForm">
    <mat-label>{{ ("code" | i18n) || "CODE" }}</mat-label>
    <ng-otp-input
      class="otp-input"
      data-cy="two-fa-auth-code"
      [formCtrl]="$any(authForm).controls?.authCode"
      [config]="config"></ng-otp-input>
    <mat-error
      class="input-error"
      *ngIf="accountService.invalidAuthCode | async">
      {{
        ("codeInvalidORExpired" | i18n) || "Code ist ungültig oder abgelaufen"
      }}
    </mat-error>
    <mat-error
      class="input-error"
      *ngIf="
        authForm?.controls?.authCode?.errors?.required &&
        !(accountService.invalidAuthCode | async)
      ">
      {{ ("requiredField" | i18n) || "Pflichtfeld" }}
    </mat-error>
  </form>

  <div class="resend-code">
    <a
      data-cy="two-fa-resend-code-link"
      class="resend-code-link"
      [class.disabled]="resendLockInSeconds !== 0"
      (click)="resendSMS()">
      {{ ("resendAuthCode" | i18n) || " Code erneut senden" }}
    </a>
    <div *ngIf="resendLockInSeconds !== 0">{{ resendLockInSeconds }}</div>
  </div>
  <a
    mat-button
    (click)="goBack()">
    {{ ("back" | i18n) || "zurück" }}
  </a>
</div>
